<template>
  <v-container fluid d-flex justify-center id="scrolling-techniques-7" class="overflow-y-auto" key="boilercal">
    <v-row class="max-w">
      <v-col cols="12" class="px-0">
        <template v-for="(day,i) in days">
          <div :key="i">
            <calendar-card :day="day" :dayNr="i" :iCopy="iCopy" :calendarSetting="calendarSetting" v-on:select-nothing="selectNothing" v-on:select-all="selectAll" v-on:copy-from="copyFrom" v-on:copy-to="copyTo"></calendar-card>
            <v-divider :inset="false" v-if="i < 6"></v-divider>
          </div>
        </template>
      </v-col>
    </v-row>
    <transition name="scale-transition">
    <div class="float-save" v-show="modified">
      <v-btn x-large elevation="9" color="infoo" class="btn-secondary" 
        @click="saveCalendar"
        :loading="saving"
        :disabled="saving"
      >{{ $t('zapisz') }}</v-btn>
    </div>
    </transition>
  </v-container>
</template>

<script>
import CalendarCard from './../components/CalendarCard.vue'
import { isArray } from 'util';
import Selection from "@simonwep/selection-js";
import _ from 'lodash';
export default {
  data: () => ({
    days: [
      {name: 'Poniedziałek'},
      {name: 'Wtorek'},
      {name: 'Środa'},
      {name: 'Czwartek'},
      {name: 'Piątek'},
      {name: 'Sobota'},
      {name: 'Niedziela'},
    ],
    calendarSetting: [],
    selection: undefined,
    firstTouched: false,
    firstSelected: false,
    iCopy: null,
    modified: false
  }),
  computed: {
    controllerId() {
      return this.$route.params.controllerId;
    },
    moduleName() {
      return 'c' + this.controllerId;
    },
    saving() {
      if (this.$store.state[this.moduleName] !== undefined) {
        return this.$store.state[this.moduleName].saving
      } else {
        return true
      }
    }
  },
  created () {
    if (!(this.$store && this.$store.state && this.$store.state[this.moduleName])) {
      this.$router.push({ path: '/dashboard/' + this.controllerId });
    } else {
      this.getCalendar(true)
      .then(res => {
        if (isArray(this.$store.getters[`${this.moduleName}/valveCalendarArray`])) {
          this.calendarSetting = this.$store.getters[`${this.moduleName}/valveCalendarArray`];
        }
        this.setupSelection();
      });
    };
  },
  beforeDestroy() {
    this.selection.destroy();
  },
  methods: {
    getCalendar(forced) {
      return this.$store.dispatch(`${this.moduleName}/getValveCalendarParams`, forced)
    },
    setupSelection() {
      //var firstTouched = false, firstSelected = false;
      this.selection = Selection.create({
        class: 'selection',
        selectables: ['.calendar > div'],
        boundaries: ['.calendar']
      }).on('move', ({changed: {removed, added}}) => {
        if (added.length && this.firstTouched === false) {
          this.firstTouched = true;
          this.firstSelected = (added[0].classList.contains('selected')) ? true : false;
        }
        for (const el of added) {
          if (this.firstSelected) {
            el.classList.remove('selected');
          } else {
            el.classList.add('selected');
          }
        }
      }).on('stop', ({inst}) => {
        inst.keepSelection();
        this.firstTouched = false;
        this.firstSelected = false;
        this.saveSelection(inst._targetContainer);
      });
    },
    saveSelection: _.debounce(function (dayContainer) {
      var dayData = [],
      iStart = dayContainer.id,
      n = dayContainer.children.length;

      for (var i=0; i<n; i++) {
        dayData[i] = (dayContainer.children[i].classList.contains('selected')) ? 1 : 0;
      }
      this.calendarSetting.splice(iStart, n, ...dayData);
      this.modified = true;
    }, 400),
    selectNothing(iStart) {
      let s = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
      this.calendarSetting.splice(iStart, 48, ...s);
      this.modified = true;
    },
    selectAll(iStart) {
      let s = [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1];
      this.calendarSetting.splice(iStart, 48, ...s);
      this.modified = true;
    },
    copyFrom(iStart) {
      this.iCopy = iStart;
    },
    copyTo(iStart) {
      if (this.iCopy !== null) {
        var dayData = [],
        dayContainer = document.getElementById(this.iCopy),
        n = dayContainer.children.length;

        for (var i=0; i<n; i++) {
          dayData[i] = (dayContainer.children[i].classList.contains('selected')) ? 1 : 0;
        }
        this.calendarSetting.splice(iStart, n, ...dayData);
        this.modified = true;
      }
    },
    saveCalendar() {
      this.$store.dispatch(`${this.moduleName}/setBoilerCalendarParams`, { 
        schedule: this.$store.getters[`${this.moduleName}/calendarArrayToParams`](this.calendarSetting)
      }).then(res => {
        if (res.error) {
          this.$store.commit("alert", {
            color: "error",
            text: res.error.code
          });
        } else {
          this.$router.push({ path: '/dashboard/' + this.controllerId });
        }
      });
    },
    calendarSettingToParams() {
      var results = [],
      arr = [...this.calendarSetting],
      final = [];
      
      while (arr.length) {
        results.push(arr.splice(0, 16));
      }
      results.forEach(function(el) {
        final.push(parseInt(el.reverse().join(''), 2));
      });
      
      return final; 
    }
  },
  components: {
    CalendarCard
  }
}
</script>

<style>

</style>
